// extracted by mini-css-extract-plugin
export default {"scrollWrapper":"Scrollable-module_scrollWrapper__TU6HW","scrollable":"Scrollable-module_scrollable__YTK2d"};